import { useQuery } from '@tanstack/react-query'
import { t } from 'i18n-js'
import { useDispatch } from 'react-redux'
import { getUserResortList } from 'services/auth.service'
import api from 'services/baseApi'
import { User } from 'store/ducks'
import { setUserResortList, userInfoSuccess } from 'store/ducks/auth/actions'

const useUser = () => {
  const dispatch = useDispatch()
  return useQuery<User>({
    queryKey: ['user'],
    queryFn: async () => {
      const { data } = await api.get('user')
      const resortListData = await getUserResortList()

      dispatch(userInfoSuccess(data))
      dispatch(setUserResortList(resortListData))
      return data
    },
    throwOnError(error) {
      console.error('[useUser] Error occurred:', {
        error,
        errorType: typeof error,
        errorName: error && typeof error === 'object' && 'name' in error ? error.name : 'N/A',
        errorMessage: error && typeof error === 'object' && 'message' in error ? error.message : 'N/A',
        errorStack: error && typeof error === 'object' && 'stack' in error ? error.stack : 'N/A'
      })
      
      if (error && typeof error === 'object' && 'name' in error) {
        throw Error(t(error.name))
      }
      throw error
    },
    enabled: false,
    retry: 3
  })
}
export default useUser
